"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RideStatus = exports.UserRole = exports.DeliveryOptions = void 0;
var DeliveryOptions;
(function (DeliveryOptions) {
    DeliveryOptions["Car"] = "Car";
    DeliveryOptions["Bike"] = "Bike";
    DeliveryOptions["Scooter"] = "Scooter";
    DeliveryOptions["Truck"] = "Truck";
    DeliveryOptions["Walking"] = "Walking";
})(DeliveryOptions || (exports.DeliveryOptions = DeliveryOptions = {}));
var UserRole;
(function (UserRole) {
    UserRole["Passenger"] = "Passenger";
    UserRole["Carrier"] = "Carrier";
})(UserRole || (exports.UserRole = UserRole = {}));
// export interface Location {
//   lat: number;
//   long: number;
//   address: string;
//   description: string;
//   homeImage?: string;
// }
var RideStatus;
(function (RideStatus) {
    RideStatus["Pending"] = "Pending";
    RideStatus["Accepted"] = "Accepted";
    RideStatus["InProgress"] = "InProgress";
    RideStatus["Rejected"] = "Rejected";
    RideStatus["Completed"] = "Completed";
    RideStatus["Cancelled"] = "Cancelled";
})(RideStatus || (exports.RideStatus = RideStatus = {}));
//# sourceMappingURL=riderApp.js.map